<template>
  <div>
    <NavBar  :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
        
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 556px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext" :class="formatvhtml"></h1>
        </div>
      </main>
    </section>


    <section class="goalsperfsec">
      <div class="upcomingeventsdiv">
        
        <div class="row align-items-start">
          <div class="col-xs-12 col-sm-12 col-md-6">
            <PresentationSection :presentdata="presentdata" />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 formatrightcol">
            <div class="eventtitles">UPCOMING EVENTS</div>
            <EventspanelCollapsible :eventdata="upcomingevents" :accodionid="1" />
          </div>
        </div>
      </div>
    </section>

  <section class="pastevents">
    <div class="col-xs-12 col-sm-12 col-md-12 pastevents">
      <div  class="eventtitles">PAST EVENTS</div>
      <EventspanelCollapsible :eventdata="pastevents" :accodionid="2"/>
    </div>
  </section>
    <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import PresentationSection from '@/components/PresentationSection.vue';
import EventspanelCollapsible from '@/components/EventspanelCollapsible.vue';

require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';
import moment from 'moment';



export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage,  PresentationSection, EventspanelCollapsible
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  myPicUrl: '',


  breadcrumbsinfo: [],

  copymsg: '',

  presentdata: [],
  upcomingevents: [],
  pastevents: [],
  }
},
methods: {
  //method to format dates. please install moment using npm i moment
  async dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
  },
async mounted() {
  this.myPicUrl = myUrlPath
  

   await axios.get('allpagespv/eventpresent').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
      console.log(error)
    })



  //------------breadcrumbs mappings info---------------
  await axios.get('getbreadcrumbsinfo/eventpresent').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })

  //------------upcoming presentation---------------
  axios.get('geteventcaption/eventpresent').then(
    response => {
        this.presentdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })

   //------------upcoming events filter---------------
   axios.get('getupcomingevents/eventpresent').then(
    response => {
        this.upcomingevents = response.data
    })
  .catch((error) => {
      console.log(error)
    })

  //------------upcoming events past events---------------
  axios.get('getpastevents/eventpresent').then(
    response => {
        this.pastevents = response.data
    })
  .catch((error) => {
      console.log(error)
    })

    
}
}
</script>

<style scoped>


.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}


.pastevents {
  background-color: rgb(219, 222, 226);
}

.goalsperfsec {
  margin-top: 250px;
}

.eventtitles {
  font-weight: bold;
  font-size: 26px;
  padding-left: 30px;
  color: rgb(119, 142, 151);
  padding-bottom: 5px;
  padding-top: 40px;
}

.breadcrumbcss {
  height: 200px;
}
.videosection {
  margin-top: -10px;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {

  .pastevents {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .upcomingeventsdiv {
    padding-left: 15px;
    padding-right: 15px;
  }
  .formatrightcol {
    padding-bottom: 40px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }

 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
 
   .pastevents {
     padding-left: 10px;
     padding-right: 10px;
     padding-top: 50px;
     padding-bottom: 50px;
   }
   .upcomingeventsdiv {
     padding-left: 15px;
     padding-right: 15px;
   }
   .formatrightcol {
     padding-bottom: 40px;
   }
   .txtdata {
    margin-bottom: 200px;
    width: 600px;
    padding-right: 10px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .txtdata {
    margin-bottom: 30px;
    width: 700px;
    padding-right: 10px;
  }
 }

 /* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
   .pastevents {
     padding-left: 80px;
     padding-right: 80px;
     padding-top: 50px;
     padding-bottom: 50px;
   }
   .upcomingeventsdiv {
     padding-left: 80px;
     padding-right: 80px;
   }
   .formatrightcol {
     padding-bottom: 40px;
   }
   .txtdata {
    margin-bottom: 100px;
    width: 800px;
    padding-right: 10px;
  }
 }


 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .pastevents {
    padding-left: 100px;
    padding-right: 100px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .upcomingeventsdiv {
    padding-left: 200px;
    padding-right: 200px;
  }

 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

}

  
@media only screen and (min-width: 1600px) {

  } 
</style>
